import _classCallCheck from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/createClass";
import isPlainObject from 'is-plain-obj';
import { safeValues } from './Devtools';
export var IS_TEST = process.env.NODE_ENV === 'test';
export var IS_PRODUCTION = process.env.NODE_ENV === 'production';
export var IS_DEVELOPMENT = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export var IS_OPERATOR = Symbol('operator');
export var MockedEventEmitter =
/*#__PURE__*/
function () {
  function MockedEventEmitter() {
    _classCallCheck(this, MockedEventEmitter);
  }

  _createClass(MockedEventEmitter, [{
    key: "emit",
    value: function emit() {}
  }, {
    key: "emitAsync",
    value: function emitAsync() {}
  }, {
    key: "on",
    value: function on() {}
  }, {
    key: "once",
    value: function once() {}
  }, {
    key: "addListener",
    value: function addListener() {}
  }]);

  return MockedEventEmitter;
}();
export function getFunctionName(func) {
  return func.name || func.displayName || '';
}
export var makeStringifySafeMutations = function makeStringifySafeMutations(mutations) {
  return mutations.map(function (mutation) {
    return Object.assign({}, mutation, {
      args: safeValues(mutation.args)
    });
  });
};
export function deepCopy(obj) {
  if (isPlainObject(obj)) {
    return Object.keys(obj).reduce(function (aggr, key) {
      if (key === '__esModule') {
        return aggr;
      }

      var originalDescriptor = Object.getOwnPropertyDescriptor(obj, key);
      var isAGetter = originalDescriptor && 'get' in originalDescriptor;
      var value = obj[key];

      if (isPlainObject(value) && !isAGetter) {
        aggr[key] = deepCopy(value);
      } else {
        Object.defineProperty(aggr, key, originalDescriptor);
      }

      return aggr;
    }, {});
  } else if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return deepCopy(item);
    });
  }

  return obj;
}
export function mergeState(originState, oldState, nextState) {
  function merge(origin, old, next) {
    if (isPlainObject(old) && isPlainObject(next)) {
      var newBranch = {};

      for (var key in next) {
        newBranch[key] = merge(origin[key], old[key], next[key]);
      }

      return newBranch;
    }

    if (typeof next === 'function') {
      return next;
    } // We return the existing array, as arrays are typically
    // mutated, not set with new values as initial state


    if (Array.isArray(old) && Array.isArray(next)) {
      return old;
    } // If we have changed a state from origin, keep that
    // changed state


    if (next === origin && old !== origin) {
      return old;
    }

    return next;
  }

  return merge(originState, oldState, nextState);
}